<template>
  <div class="container">
    <section>
      <b-navbar>
        <template slot="end">
          <date-range-selector v-model="dateRange" @input="onDateRangeSelected" />
        </template>
      </b-navbar>

      <div class="stats-area">
        <quick-stats-section v-if="!loading" v-bind="stats" @requeued-docs="refreshStats" />
        <p class="loading-indicator" v-else>
          <b-icon icon="loading" custom-class="mdi-spin"></b-icon>
          Loading...
        </p>
      </div>
    </section>
    <live-stats />
  </div>
</template>

<script>
  import format from 'date-fns/format'
  import { TODAY } from '../const'
  import { getStats } from '../api'
  import { getPresetDates } from '../utils'
  import LiveStats from '@/components/LiveStats'
  import QuickStatsSection from '../components/QuickStatsSection'
  import DateRangeSelector from '../components/DateRangeSelector'

  export default {
    name: 'Status',
    components: { QuickStatsSection, DateRangeSelector, LiveStats },
    data () {
      return {
        loading: true,
        stats: {},
        dateRange: {
          preset: TODAY,
          start: null,
          end: null
        }
      }
    },
    mounted() {
      this.refreshStats()
    },
    methods: {
      formatDate (dt, formatStr = 'yyy-MM-dd') {
        return format(dt, formatStr)
      },
      onDateRangeSelected () {
        // this.dateRange = dateRange
        this.refreshStats()
      },
      async refreshStats () {
        this.loading = true
        const dateRange = this.dateRange
        const dates = getPresetDates(dateRange.preset, dateRange.start, dateRange.end)
        try {
          const statsDateRange = {
            date_start: dates.dateStart,
            date_end: dates.dateEnd
          }
          const stats = await getStats(statsDateRange)
          this.stats = { ...stats, ...dates }
        } catch {
          this.$buefy.toast.open({
            message: `Failed loading stats. An error occurred.`,
            type: 'is-danger'
          })
        }
        this.loading = false
      }
    }
  }
</script>

<style scoped>
  .container > section {
    margin-bottom: 30px;
  }
  .loading-indicator {
    font-size: 20px;
    text-align: center;
    margin: 30px auto;
    line-height: 30px;
  }
</style>
